<template class="section">
    <div class="container">
        <div class="columns">
            <b-alert
                v-model="alert.show"
                :variant="alert.variant || 'info'"
                id="login-alert"
                dismissible
            >
                {{alert.message}}
            </b-alert>

            <h1
                style="
                    margin-bottom:44px; 
                    color:#fff; 
                    text-align:center; 
                    margin-top:44px
                "
            >Account Setup</h1>

            <div class="column is-8 is-offset-2">
                <stepper 
                    :steps="steps" 
                    :model="model"
                    :reset="reset"
                    :setStep ="activeStep"

                    @completed-step="completeStep"
                    @active-step="isStepActive" 
                    @stepper-finished="submit"
                    @emit-model="spreadModel"
                />
            </div>
        </div>
    </div>
</template>

<script>

    import { get_account, register_account } from './../../networking/account'
    import { create_default_alerts} from '../../networking/alerts'
    import { createToken } from 'vue-stripe-elements-plus'
    import { get_plans } from './../../networking/devices'
    import deviceApi from './../../device_apis'

    import Stepper from './../../widgets/Stepper'
    import AccountStep from './AccountStep'
    import AgreementStep from './AgreementStep'
    import AddressStep from './AddressStep'
    import PaymentStep from './PaymentStep'
    import {get_latest_installation_for_device} from "@/networking/installations";

    const default_error_msg = 'Device subscription failed'

    export default {
        components: {
            Stepper
        },

        data(){
            return {
                reset: false,
                activeStep: null,
                model: { account:{} },
                alert: { show:false, message:'', variant:'' },
                steps: [{
                        icon: 'person',
                        name: 'first',
                        title: 'Account',
                        component: AccountStep,
                        completed: false,
                        canContinue: true
                    }, {
                        icon: 'mail',
                        name: 'second',
                        title: 'Address',
                        component: AddressStep,
                        completed: false,
                        canContinue: true
                    }, {
                        icon: 'attachment',
                        name: 'third',
                        title: 'Agreements',
                        component: AgreementStep,
                        completed: false,
                        canContinue: true
                    },{
                        icon: 'credit_card',
                        name: 'fourth',
                        title: 'Payment',
                        component: PaymentStep,
                        completed: false,
                        canContinue: true,
                }]
            }
        },

        async created(){
            const account_generator = get_account(JSON.parse(localStorage.getItem('user')).accountId)
            const { value: { data = {} } } = await account_generator.next()
            this.model.account = data

            const generator = get_latest_installation_for_device(data['device_id'])
            const { value } = await generator.next()
            const installation = value['data']

            this.model = { ...this.model, installation: installation }

            const { value: { data: plans } } = await get_plans()
            this.model = { ...this.model, plans: plans, selectedPlan: null }
        },
        
        methods: {

            // Executed when @stepper-finished event is triggered
            async submit() {
                document.getElementById('registration_container').scrollIntoView({behavior: 'smooth' })
                
                try {
                    this.validate_fields()
                    await this.tokenizeCard()
                    await this.completeRegister()
                    await this.subscribeDevice()
                    this.createDefaultAlerts()
                    this.alert = {show: true, message: "Success!", variant: 'success'}
                    this.$emit('logOut')
                } catch(e){ 
                    this.alert = {
                        show: true, 
                        message: e.message || default_error_msg, 
                        variant: e.variant || 'danger', 
                    }
                }
            },

            validate_fields(){
                const { account_name, first_name, last_name, email, password, line_1 } = this.model.account
                if(!account_name || !first_name || !last_name || !email || !password){
                    this.reset = true
                    throw { message: 'Please complete the missing fields \uD83D\uDE04', variant: 'info' }
                } else if (!line_1){
                    this.activeStep = 1
                    throw { message: 'Please complete the missing fields', variant: 'info' }
                } else if (!this.model.selectedPlan){
                    throw { message: 'Please Select a Service Plan', variant: 'info' }
                } else {
                    this.alert = { show: true, message: 'Waiting for Response...' }
                }
            },

            async tokenizeCard() {
                try {
                    const { token } = await createToken()
                    this.model.account.stripe_token = token.id
                } catch (e) { throw  {}}
            },

            async completeRegister(token) {
                const account_generator = register_account(this.model.account)
                const { value: { alert = { variant: 'danger' }}} = await account_generator.next()
                if(alert.variant === 'danger' ){ throw { message: alert.message }}
            },

            async subscribeDevice() {
                try {
                    await deviceApi.subscribeDevice({ service_plan_id: this.model.selectedPlan })
                } catch (e) { throw  { message: e.response && e.response.data && e.response.data.message }}
            },

            createDefaultAlerts(){ create_default_alerts(this.model.account.account_id)},

            // Executed when @completed-step event is triggered
            completeStep(payload){
                this.steps.forEach((step) => {
                    if (step.name === payload.name) {
                        step.completed = true
                    }
                })
            },

            // Executed when @active-step event is triggered
            isStepActive(payload){
                this.steps.forEach((step) => {
                    if (step.name === payload.name) {
                        if(step.completed === true) {
                            step.completed = false
                        }
                    }
                })
            },

            spreadModel(submodel){ this.model = {...this.model, ...submodel} }
        }
    }

</script>
